import React from 'react';
import { UserOutlined, DashboardOutlined, UnlockOutlined, LogoutOutlined } from "@ant-design/icons";
import { NavLink } from 'react-router-dom';

const AdminProfileMenu = (user, isPermissionLoaded, hasPermission, t, lang, getLangUrl, getAdminLangUrl, getUserLangUrl) => (
    <div className="profile-menu rounded">
        <div className="user-profile-block p-3">
            <UserOutlined className="float-end ms-1 mt-2 h4" style={{ color: '#ededed' }} />
            <div>
                <strong>{user?.name}</strong><br />
                {user?.email}
            </div>
        </div>

        <nav className="profile-menu-list">
            <ul>
                <li>
                    <NavLink className="profile-menu-link" to={getAdminLangUrl(lang, '/')}>
                        <DashboardOutlined className="me-1" /> {t('Dashboard')}
                    </NavLink>
                </li>
                <li>
                    <NavLink className="profile-menu-link" to={getAdminLangUrl(lang, '/setting/my-account/change-password')}>
                        <UnlockOutlined className="me-1" /> {t('Change Password')}
                    </NavLink>
                </li>
                <li className="divider"></li>
                <li>
                    <NavLink className="profile-menu-link logout-menu-link" to={getLangUrl(lang, '/auth/logout')}>
                        <LogoutOutlined className="me-1" /> {t('Logout')}
                    </NavLink>
                </li>
            </ul>
        </nav>
    </div>
);

export default AdminProfileMenu;
